// Templates in the root of the templates folder land here
export const OTHER_DOCUMENT_TEMPLATE_CATEGORY = 'Other'
